import * as React from "react";
import {GridColDef} from "@mui/x-data-grid";
import {formatTime, stringAvatar} from "@/helper/method";
import {ProTable} from "@/widget/ProTable/ProTable";
import {PaybackPageVO, useQueryPaybackPage} from "@/service/payback.s";
import Box from "@mui/material/Box";
import {ReviewStatus} from "@/widget/ReviewStatus/ReviewStatus";
import {useAuthInfo} from "@/store/account.c";
import {WritePayback} from "@/pages/Payback/WritePayback";
import {ViewPayback} from "@/pages/Payback/ViewPayback";
import {PatentPageVO} from "@/service/patent.s";
import {permScope} from "@/helper/constant";
import {SellerAvatar} from "@/widget/SellerAvatar/SellerAvatar";

export const PaybackedListPage = () => {
    const {
        mutate: paybackPageMutate,
        data: paybackPageData,
        isPending: paybackPagePending,
    } = useQueryPaybackPage()
    const {role: {dataScope}, id} = useAuthInfo()

    const columns: GridColDef<PaybackPageVO>[] = [
        {field: "customerName", headerName: "客户名称", flex: 1.3,},
        {
            field: "productName",
            headerName: "业务内容",
            flex: 0.6,
            valueFormatter: (value: string) => value || "-"
        },
        {
            field: "seller",
            headerName: "业务人员",
            headerAlign: "center",
            align: "center",
            flex: 0.6,
            display: "flex",
            valueGetter: (_, row) => ({creator: row.creator, seller: row.seller}),
            renderCell: SellerAvatar
        },
        {
            field: "paymentMoney",
            headerName: "回款金额",
            headerAlign: "center",
            align: "center",
            flex: 0.6,
            renderCell: ({row}) => <Box color={'red'} component={'span'}>{`￥${row.paymentMoney}`}</Box>
        },
        {
            field: "paymentDate",
            headerName: "回款时间",
            headerAlign: "center",
            align: "center",
            valueFormatter: (value) => formatTime("D", value),
            flex: 0.8
        },
        {
            field: "paymentMethod",
            headerName: "回款方式",
            headerAlign: "center",
            align: "center",
            flex: 0.8,
        },
        {
            field: "nodeNames",
            headerName: "审核状态",
            headerAlign: "center",
            align: "center",
            flex: 0.8,
            renderCell: ({row}) => <ReviewStatus processorIds={row.processorIds} authId={id} auditStatus={row.auditStatus} nodeNames={row.nodeNames}/>,
        },
        {
            field: "createdAt",
            headerName: "创建时间",
            headerAlign: "right",
            align: "right",
            flex: 0.6,
            valueFormatter: (value) => formatTime("D", value),
        },
    ];

    return (
        <ProTable<PaybackPageVO>
            loading={paybackPagePending}
            columnVisibilityModel={{seller: dataScope !== permScope['self']}}
            renderDrawer={{view: <ViewPayback mode={'drawer'} flag={1}/>, write: <WritePayback flag={1}/>}}
            columns={columns}
            drawerProps={{
                view: {
                    hiddenFooter: true,
                    viewBtnCallback: (row: PatentPageVO) => {
                        return {businessId: row.id, instanceId: row.instanceId, updateForm: <WritePayback flag={1}/>}
                    }
                }
            }}
            data={paybackPageData?.data}
            onSearch={(params) => {
                paybackPageMutate({...params, flag: "1"});
            }}
            code={"paybacked"}
        />
    );
};
